<template>
  <div>
    <div><label><input type="radio" v-model="combineType" value="0"> препарат для продажи</label></div>
    <div><label><input type="radio" v-model="combineType" value="1"> препарат состоит из нескольких
      компонентов</label></div>
    <div><label><input type="radio" v-model="combineType" value="2"> препарат не для продажи, так как является
      компонентом</label></div>
    <div v-if="+combineType === 1">
      <DrugSearchNew
        ref="drugForCombine"
        :onSelect="(d) => addDrugToCombine(d)"
      />
      <div v-if="combinedList.length">
        <table class="table table-sm table-hover mt-1">
          <thead>
          <tr>
            <th></th>
            <th>препарат</th>
            <th>количество</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(d,i) in combinedList">
            <td>{{ i + 1 }}</td>
            <td>{{ d.title }}</td>
            <td><input type="number" v-model="d.rate" class="form-control"></td>
            <td>
              <button @click="removeFromCombine(i)" class="btn btn-sm btn-outline-danger"><i
                class="icon-fa icon-fa-trash"/></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  props: ['drugIsCombined', 'selectedCombineType', 'selectedCombinedList'],
  components: {DrugSearchNew},
  data() {
    return {
      combineType: 0,
      isCombined: false,
      combinedList: []
    }
  },
  created() {
    if (this.selectedCombineType) {
      this.combineType = +this.selectedCombineType;
    }
    if (this.drugIsCombined) {
      this.isCombined = true;
    }
    if (this.selectedCombinedList) {
      this.combinedList = this.selectedCombinedList.map((l) => {
        return {id: l.id, drug_id: l.drug.id, title: l.drug.title, rate: l.rate};
      })
    }
  },
  methods: {
    addDrugToCombine(drug) {
      this.$refs.drugForCombine.drug = null;
      this.combinedList.push({drug_id: drug.id, title: drug.title});
    },
    removeFromCombine(index) {
      delete this.combinedList[index];
      this.combinedList = this.combinedList.filter(c => c)
    },
  }
}
</script>
